import { mapState, mapGetters } from 'vuex';

import UserAvatar from '@/components/ui/user-avatar';

import { getInitials, getRandomColor } from '@/helpers/functions';
import { resolveTerm } from '@/helpers/terms';
import { messageContextTypes } from '@/helpers/messageContextTypes';
import { TemplateName } from '~/helpers/templateType';

import { ABtn } from '@maisaedu/ui-components-a-btn';
import { ATooltip } from '@maisaedu/ui-components-a-tooltip';

import CommonMixin from '@/mixins/templates/common';

export default {
  props: {
    showList: {
      type     : Boolean,
      default  : false,
      required : true
    },
    academicMainId: {
      type     : Number,
      default  : null,
      required : true
    },
    positionX: {
      type    : Number,
      default : 1000
    },
    positionY: {
      type    : Number,
      default : 90
    },
    teachers: {
      type     : Array,
      default  : () => ([]),
      required : true
    }
  },
  components: {
    UserAvatar,
    ABtn,
    ATooltip
  },
  mixins: [CommonMixin],
  data() {
    return {
      TemplateName
    };
  },
  computed: {
    ...mapState({
      hasInactiveContextLock: state => state.messages.hasInactiveContextLock
    }),
    ...mapGetters({
      getterCourse   : 'plataforma/newContent/getterCourse',
      getterContent  : 'plataforma/newContent/getterContent',
      isImpersonated : '_core/auth/isImpersonated'
    }),
    hasSendMessageBlock() {
      if (this.currentContext) {
        return this.currentContext.isAcademicMainExpired && this.hasInactiveContextLock;
      }
      return false;
    },
    currentContext() {
      return this.getterCourse.context ? this.getterCourse.context : this.getterContent.context;
    },
    isAllowedToSendMessageToAllTeachers() {
      return this.teachers.length > 1 && this.teachers.some(teacher => teacher.isVisibleToStudentSendMessage);
    }
  },
  methods: {
    resolveTerm,
    getInitials,
    getRandomColor,
    parseParticipantToMessageContact(participant) {
      return {
        name           : participant.name,
        email          : participant.email,
        safeaRole      : participant.safeaRole,
        roleAlias      : participant.safeaRole,
        externalUserId : String(participant.safeaUserId),
        imagePath      : participant.profilePhoto,
        contexts       : [{
          contextType  : messageContextTypes.COURSE,
          externalId   : String(this.academicMainId),
          name         : this.currentContext.academicMainName,
          externalCode : this.currentContext.academicMainExternalId
        }]
      };
    },
    sendMessageToAllTeachers() {
      const selectedContacts = [];
      this.teachers.forEach(teacher => {
        teacher.isVisibleToStudentSendMessage && selectedContacts.push(this.parseParticipantToMessageContact(teacher));
      });

      this.handleSendMessage(selectedContacts);
    },
    sendMessageToTeacher(teacher) {
      const selectedContact = [this.parseParticipantToMessageContact(teacher)];

      this.handleSendMessage(selectedContact);
    },
    handleSendMessage(selectedContacts) {
      this.$nuxt.$emit('openMessageModal', {
        contexts: [{
          contextType  : messageContextTypes.COURSE,
          externalId   : String(this.academicMainId),
          name         : this.currentContext.academicMainName,
          externalCode : this.currentContext.academicMainExternalId
        }],
        defaultBoxFilter: 'inbox',
        selectedContacts
      });

      this.$emit('close');
    }
  }
};
